import { render, staticRenderFns } from "./facebook-page-insight-metric-selector.vue?vue&type=template&id=237b8dca"
import script from "./facebook-page-insight-metric-selector.vue?vue&type=script&lang=js"
export * from "./facebook-page-insight-metric-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports